import(/* webpackMode: "eager" */ "/app/libs/utils-web/src/lib/common/i18n/LanguageChangeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/utils-web/src/lib/common/i18n/TranslationsClientProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@unleash/nextjs/dist/FlagProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@unleash/nextjs/dist/hooks.js");
